import { z } from 'zod';
import { MapEntity, mapEntitySchema } from 'app/agriculture/queries/types/geometry/MapEntity';
import {
    mockPointGeometry,
    PointGeometry,
    pointGeometrySchema,
} from 'app/agriculture/queries/types/geometry/PointGeometry';

export interface Trough extends MapEntity {
    id: string;

    creatorId: number;
    createdAt: Date;
    updatedAt: Date;

    name: string;

    geometry: PointGeometry;
}

export const troughSchema = mapEntitySchema.extend({
    id: z.string().uuid(),
    creatorId: z.number(),
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),
    name: z.string(),
    geometry: pointGeometrySchema,
});

export const mockTrough = ({
    id = 'f276199e-3b2a-4ca4-ac0e-4d1d3a768346',

    creatorId = 1,
    createdAt = new Date(),
    updatedAt = new Date(),

    name = 'Mock Trough Name',

    geometry = mockPointGeometry(),
}: Partial<Trough> = {}): Trough => ({
    id,
    creatorId,
    createdAt,
    updatedAt,
    name,
    geometry,
});
